module.exports = __webpack_public_path__ + "img/clock_icon.c4997abf.svg";